import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
// import Arun from '../assets/images/vice_chancellor_img.jpg'
// import Alex from '../assets/images/Alex Stojcevski.jpg'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'
import APAQA from '../assets/images/APAQA_Logo.png'

function About() {
    return (
        <div>
            <div className="about-layout">
                <main className="about-main">
                    <h2>About IETEC</h2>
                    <h3>International Engineering and Technology Education Conference (IETEC)</h3>
                    <p>
                        The <span className="font-italic">International Engineering and Technology Education Conference</span> (IETEC) is a series of conferences initiated and coordinated by a team of engineering, technology, business and health educators from around the globe which has now transformed to an open, collegial and supportive working group. The IETEC involves multiple like minded universities and organisations from around the world. The IETEC features significant keynote addresses, plenary presentation sessions, interactive workshops, a panel discussion, exhibition stalls and opportunities for international collaborations. The IETEC provides opportunities and forum for engineering & technology and business educators to discuss important issues and develop strategies to foster engineering & technology and business education.
                    </p>
                    <p>The inaugural IETEC (IETEC’11) was successfully organised and staged at Taylor’s University, Kuala Lumpur, Malaysia in January 2011 with collaboration between Central Queensland University, Australia and three Malaysian universities, i.e. Taylor’s University, Universiti Teknologi Malaysia (UTM) and Universiti Tun Hussein Onn (UTHM) Malaysia.</p>
                    <p>After an inaugural staging, IETEC was subsequently staged alternate years in Ho Chi Minh City, Vietnam (2013); Sibiu, Romania (2015); and Hanoi, Vietnam (2017) with a substantial support fro several Australia, European, Malaysian, Vietnamese and Indian universities and industry partners.</p>
                    <p className='no-newline-after-p'>Professor Arun Patil</p>
                    <p>Founding General Chair</p>
                </main>

                <aside className="about-sidebar">
                    <h3>Past IETEC Conferences</h3>
                    <ul className="pl-5">
                        <li><a href="http://ietec.apaqa.org/ietec17/" target="_blank" rel="noreferrer noopener">IETEC’17</a></li>
                        <li><a href="http://ietec.apaqa.org/ietec15/" target="_blank" rel="noreferrer noopener">IETEC’15</a></li>
                        <li><a href="http://ietec.apaqa.org/ietec13/" target="_blank" rel="noreferrer noopener">IETEC’13</a></li>
                        <li><a href="http://ietec.apaqa.org/ietec11/" target="_blank" rel="noreferrer noopener">IETEC’11</a></li>
                    </ul>
                </aside>

            </div>
            <section className="sponsor-strip">
                <h4>Proudly supported by</h4>

                <div className="sponsor-strip-logos">
                    <img src={S0} alt="" />
                    <img src={S3} alt="" />
                    <img src={CurtinLogo} alt="" />
                    <img src={APAQA} alt="" />
                </div>
            </section>
        </div>
        
    )
}

export default About